module.exports = __webpack_public_path__ + "img/img-new-kakao-ch2@2x.8f05479d.png";